import * as Sentry from '@sentry/browser';

if (PRODUCTION) {
  // Setup error tracking
  Sentry.init({
    dsn: 'https://ce4a0d688e2c4287ace96ac9979792c6@sentry.io/1460437',
  });
}
